import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  flex: ${({ flex }) => flex || "1 0 auto"};
  width: ${({ width }) => width || "auto"};
  label {
    font-size: 0.9rem;
    text-align: left;
  }
`;

export const IsRequired = styled.span`
  color: #ff0000;
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #676f7e;
`;

export const TextLimit = styled.div`
  position: absolute;
  top: ${({ label }) => (label ? "10px" : "-10px")};
  right: 0px;
  font-size: 10px;
`;
